import { render, staticRenderFns } from "./clipper-basic.vue?vue&type=template&id=20c136ac&scoped=true&"
import script from "./clipper-basic.vue?vue&type=script&lang=js&"
export * from "./clipper-basic.vue?vue&type=script&lang=js&"
import style0 from "./clipper-basic.vue?vue&type=style&index=0&id=20c136ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c136ac",
  null
  
)

export default component.exports